import { useSelect } from '@wordpress/data';
import { __ } from '@wordpress/i18n';
import { Button } from '@wordpress/components';
import { useRef } from '@wordpress/element';
import type { RefObject } from 'react';
import { store as blockEditorStore } from '../../store';
import { useBlockElementRef } from '../block-list/use-block-props/use-block-refs';

/**
 * @see https://github.com/WordPress/gutenberg/blob/HEAD/packages/block-editor/src/components/skip-to-selected-block/README.md
 */
export default function SkipToSelectedBlock() {
	const selectedBlockClientId = useSelect(
		( select ) => select( blockEditorStore ).getBlockSelectionStart(),
		[]
	);
	const ref = useRef< HTMLElement | null | undefined >( undefined );
	useBlockElementRef(
		// An unset ID matches no block element.
		selectedBlockClientId as string,
		// The ref receives the selected block's element, or `null`.
		ref as RefObject< Element | null >
	);
	const onClick = () => {
		ref.current?.focus();
	};

	return selectedBlockClientId ? (
		<Button
			__next40pxDefaultSize
			variant="secondary"
			className="block-editor-skip-to-selected-block"
			onClick={ onClick }
		>
			{ __( 'Skip to the selected block' ) }
		</Button>
	) : null;
}
